<template>
  <div>
    <el-drawer
      title="唯格云产品同步器"
      :visible.sync="showDrawer"
      direction="btt"
      size="90%"
      append-to-body
      @closed="onClose"
    >
      <div class="main-container" ref="mainContainer">
        <div class="filter-row">
          <el-button size="small" icon="el-icon-search" @click="handleSearch"
            >刷新</el-button
          >
          &nbsp;
          <el-input
            placeholder="请输入内容"
            v-model="currentQuery.nameCn"
            class="input-title"
            @change="handleSearch"
            clearable
            @clear="handleSearch"
            size="small"
          >
            <el-button slot="prepend" icon="el-icon-search"></el-button>
          </el-input>
          <el-radio-group
            v-model="currentQuery.disabled"
            size="small"
            @change="handleSearch"
          >
            <el-radio-button
              v-for="item in disabledOptions"
              :label="item.id"
              :key="item.name"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="table-container" ref="tableContainer">
          <el-table
            :data="tableData"
            border
            :height="tableHeight"
            :style="tableStyle"
            :size="tableSize"
            header-cell-class-name="baseTableHeadStyle"
            ref="multipleTable"
            row-class-name="customs-table-row"
            v-loading="tableLoading"
            element-loading-text="查询中..."
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              fixed="left"
            />
            <el-table-column type="index" align="center" width="50" />
            <template v-for="column in tableColumns">
              <el-table-column
                v-if="column.showColumn"
                v-bind="column"
                :show-overflow-tooltip="true"
                :key="column.prop"
              >
                <template slot-scope="scope">
                  <span v-if="column.prop === 'nameCn'">
                    <h3>{{ scope.row.nameCn }}</h3>
                    <div>{{ scope.row.nameEn }}</div>
                  </span>
                  <span v-else-if="column.prop === 'disabled'">
                    <el-tag :type="scope.row.disabled ? 'danger' : 'success'">{{
                      scope.row.disabled ? "已禁用" : "已启用"
                    }}</el-tag>
                  </span>
                  <el-image
                    v-else-if="column.prop === 'thumbnailUrl'"
                    style="width: 66px; height: 66px;"
                    :src="scope.row.thumbnailUrl"
                    :preview-src-list="[scope.row.thumbnailUrl]"
                  >
                  </el-image>
                  <el-image
                    v-else-if="column.prop === 'cover_image_url'"
                    style="width: 66px; height: 66px;"
                    :src="scope.row.cover_image_url"
                    :preview-src-list="[scope.row.cover_image_url]"
                  >
                  </el-image>
                  <span v-else>{{ scope.row[column.prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>

        <div class="custom-table-footer">
          <el-pagination
            class="base-table-pagination"
            :disabled="tableLoading"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="page + 1"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <el-button
            class="mt-r"
            size="small"
            type="primary"
            icon="el-icon-circle-check"
            @click="handleConfrim"
            :loading="submitting"
            >{{ submitting ? "添加中..." : "添加选中项" }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ShowApiError } from "@/request/error";
import { GetProductList } from "../api/viewgres_v4";
import { PostProducts } from "../api/index";
import { GetSeriesList } from "@/views/productSeries/api/index";
import form from "../mixins/form";
import vgcColumn from "../mixins/vgcColumn";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  mixins: [form, vgcColumn],
  data() {
    return {
      tableStyle: {
        width: "100%"
      },
      tableHeight: "500px",
      tableSize: "medium",
      tableLoading: false,
      tableColumns: [],
      page: 0,
      size: 20,
      total: 0,
      tableData: [],
      orderProp: "seq",
      orderDirection: "descending",
      selections: [],
      showDrawer: false,
      submitting: false,
      currentQuery: {
        nameCn: "",
        disabled: null
      },
      disabledOptions: [
        {
          id: null,
          name: "全部"
        },
        {
          id: false,
          name: "已启用"
        },
        {
          id: true,
          name: "已禁用"
        }
      ]
    };
  },
  watch: {
    show: {
      handler(value) {
        this.showDrawer = value;
        if (this.showDrawer) {
          if (
            this.tableData.length === 0 ||
            Object.keys(this.query).length > 0
          ) {
            this.getTableData();
          }
          this.$nextTick(() => {
            this.tableHeight = `${this.$refs["tableContainer"].clientHeight}px`;
          });
        }
      },
      immediate: true
    }
  },
  created() {
    this.buildTableColumns();
  },
  methods: {
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },

    handleSearch() {
      this.page = 0;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      GetProductList({
        page: this.page,
        size: this.size,
        sort: `seq,DESC`,
        ...this.currentQuery
      })
        .then(res => {
          let { content, totalElements } = res.data;
          this.tableData = content;

          this.total = totalElements;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          ShowApiError(err, "拉取列表错误");
        });
    },
    handleSelectionChange(selections) {
      this.selections = selections;
      this.$emit("onSelectionChange", selections);
    },
    handleConfrim() {
      if (this.selections.length === 0) {
        this.$message.warning("请选择要添加的文章");
        return;
      }
      this.$confirm("是否确认将选中产品新增到系统?", "确认提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            console.log("选中的产品", this.selections);
            this.submitting = true;
            let formDatas = [];
            // PostArticle
            this.selections.forEach(element => {
              let form = this.buildFormByVgcData(element);
              formDatas.push(form);
            });
            //与当前结构的系列进行匹配
            const seriesRes = await GetSeriesList({
              page: 0,
              size: 999,
              disabled: false
            });
            const seriesIds = seriesRes.data.content.map(data => data.id);

            formDatas = formDatas.map(data => {
              if (!seriesIds.includes(data.series_ids[0])) {
                data.series_ids = [26];
              }
              return data;
            });
            await PostProducts(formDatas);
            this.$message({
              type: "success",
              message: "同步成功"
            });
          } catch (error) {
            ShowApiError(error, "同步失败");
          } finally {
            this.submitting = false;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    onClose() {
      this.showDrawer = false;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .table-container {
    box-sizing: border-box;
    flex: 1 0 0;
    padding: 0 24px;
    overflow: hidden;
  }
  .base-table {
    width: 100%;
    height: 100%;
  }
}

.custom-table-footer {
  flex: 56px 0 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
}
.input-title {
  width: 250px;
}
.filter-row {
  width: 100%;
  margin-bottom: 12px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
